import { computed, makeAutoObservable } from 'mobx';
import { SelectionModel } from 'src_common/common/websocket2/models/SelectionModel/SelectionModel';
import { TypeId } from 'src_common/common/websocket2/type';
import { ModelsState } from 'src_common/common/websocket2/ModelsState';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';
import { MobxMapAutoNew } from 'src_common/common/mobx-utils/MobxMapAutoNew';

export class HomePageCarouselSelectionState {
    private readonly selectionNameFieldStateMap: MobxMapAutoNew<string, FormInputState<string, string>>;

    constructor(
        private readonly modelsState: ModelsState,
        private readonly selectionId: number,
        private readonly getMarketModel: () => TypeId.MarketId | null,
        private readonly getSelectedSelectionsLabel: () => string | null
    ) {
        this.selectionNameFieldStateMap = new MobxMapAutoNew(
            (selectionName: string): FormInputState<string, string> => FormInputState.new(selectionName)
        );
        makeAutoObservable(this);
    }

    @computed private get selectionModel(): SelectionModel | null {
        const marketId = this.getMarketModel();

        if (marketId === null) {
            return null;
        }
        const selectionModel = this.modelsState.getSelectionAndLoad(marketId, this.selectionId);
        return selectionModel;
    }

    @computed public get value(): string {
        if (this.fieldName !== null) {
            const result = this.fieldName.result.value;
            if (result.type === 'ok') {
                return result.data;
            }
        }

        return '';
    }

    @computed public get fieldName(): FormInputState<string, string> | null {
        if (this.selectionModel !== null) {
            const selectionLabel = this.getSelectedSelectionsLabel();
            const selectionNameFieldItem = this.selectionNameFieldStateMap.get(
                selectionLabel ?? this.selectionModel.name
            );
            return selectionNameFieldItem;
        }

        return null;
    }

    @computed public get name(): string {
        return this.selectionModel?.name ?? '';
    }

    @computed public get id(): number | null {
        return this.selectionModel?.id ?? null;
    }
}
